import type { RateView } from './useImpactTree'

const RATES: RateView[] = ['total', 'daily', 'hourly']

// total = cumulative $-at-risk; daily/hourly = burn-rate view (§12.5.4).
export function RateToggle({ rate, onChange }: { rate: RateView; onChange: (r: RateView) => void }) {
  return (
    <div className="inline-flex rounded-lg border border-border-light dark:border-border-dark overflow-hidden mb-4">
      {RATES.map((r) => (
        <button
          key={r}
          onClick={() => onChange(r)}
          className={`px-3 py-1.5 text-xs capitalize ${
            rate === r
              ? 'bg-primary text-white'
              : 'text-subtle-light dark:text-subtle-dark hover:bg-primary/5'
          }`}
        >
          {r}
        </button>
      ))}
    </div>
  )
}
